import React from 'react';
import PropTypes from 'prop-types';
import { ReactPhotoSphereViewer } from 'react-photo-sphere-viewer';
import StandardLayout from '../../templates/StandardLayout';

export const FarbRaum = ({ room, setIsVisibleRoom }) => (
  <StandardLayout>
    <div className="grid-container">
      <div className="grid-x grid-margin-x">
        <div className="photoSphereViewerWrapper">
          <span
            className="closeIconWrapper"
            role="presentation"
            onClick={() => setIsVisibleRoom(false)}
          >
            <img src="/ccx-files/assets/cross-white.svg" alt="" />
          </span>
          <ReactPhotoSphereViewer
            defaultZoomLvl={1}
            src={room}
            height="85vh"
            width="100%"
            fisheye
          />
        </div>
      </div>
    </div>
  </StandardLayout>
);

FarbRaum.propTypes = {
  room: PropTypes.string,
  setIsVisibleRoom: PropTypes.func,
};
